export const BACKEND_URL = "service.loragon.xyz";
export const PUBLIC_KEY_HEX = "b36c7a039dbf428bf1c2adbc02721bb39b62e103fb36763bbcd4071994d85e3440f774a521670f7f95118b3aab4058ae108dca75a74b7d0f22dcedc755ba09dfc594c4c03136dfaebf0f0cba66f8cb71b9f00223c29b29da5746d7718c536bdb";
export const LOCATIONS: [[number, number], string][] = [
  [[38.8339, -77.3074], "Ashburn"],
  [[40.0946, -82.7541], "Columbus"],
  [[37.7749, -122.4194], "San Francisco"],
  [[45.9175, -119.2684], "Boardman"],
  [[38.8339, -77.3074], "Ashburn"],
  [[40.0946, -82.7541], "Columbus"],
  [[37.7749, -122.4194], "San Francisco"],
  [[45.9175, -119.2684], "Boardman"],
  [[38.8339, -77.3074], "Ashburn"],
  [[40.0946, -82.7541], "Columbus"],
  [[37.7749, -122.4194], "San Francisco"],
  [[45.9175, -119.2684], "Boardman"],
  [[38.8339, -77.3074], "Ashburn"],
  [[40.0946, -82.7541], "Columbus"],
  [[37.7749, -122.4194], "San Francisco"],
  [[45.9175, -119.2684], "Boardman"],
  [[38.8339, -77.3074], "Ashburn"],
  [[40.0946, -82.7541], "Columbus"],
  [[37.7749, -122.4194], "San Francisco"],
  [[45.9175, -119.2684], "Boardman"],
  [[38.8339, -77.3074], "Ashburn"],
  [[40.0946, -82.7541], "Columbus"],
  [[37.7749, -122.4194], "San Francisco"],
  [[45.9175, -119.2684], "Boardman"],
  [[38.8339, -77.3074], "Ashburn"],
  [[40.0946, -82.7541], "Columbus"],
  [[37.7749, -122.4194], "San Francisco"],
  [[45.9175, -119.2684], "Boardman"],
  [[38.8339, -77.3074], "Ashburn"],
  [[40.0946, -82.7541], "Columbus"],
  [[37.7749, -122.4194], "San Francisco"],
  [[45.9175, -119.2684], "Boardman"],
  [[38.8339, -77.3074], "Ashburn"],
  [[40.0946, -82.7541], "Columbus"],
  [[37.7749, -122.4194], "San Francisco"],
  [[45.9175, -119.2684], "Boardman"],
  [[38.8339, -77.3074], "Ashburn"],
  [[40.0946, -82.7541], "Columbus"],
  [[37.7749, -122.4194], "San Francisco"],
  [[45.9175, -119.2684], "Boardman"],
  [[38.8339, -77.3074], "Ashburn"],
  [[40.0946, -82.7541], "Columbus"],
  [[37.7749, -122.4194], "San Francisco"],
  [[45.9175, -119.2684], "Boardman"],
  [[38.8339, -77.3074], "Ashburn"],
  [[40.0946, -82.7541], "Columbus"],
  [[37.7749, -122.4194], "San Francisco"],
  [[45.9175, -119.2684], "Boardman"],
  [[38.8339, -77.3074], "Ashburn"],
  [[40.0946, -82.7541], "Columbus"]
];
